require('./brokerRightsSellStep1.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const moment = require('moment');

// @helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');

// @constants
const {
    FIRST_STEP,
    EURO_TEXT,
    BROKER_ORDER_TYPE_LIMITED,
    BROKER_RIGHTS_BUY_FIELDS_MAXLENGHT_LIMIT,
    BROKER_TYPE_RIGHT_NEW_DECIMALS,
    SATURDAY_INDEX_DAY,
    SUNDAY_INDEX_DAY
} = require('constants/index');
const language = getLanguage();
const { DATE_PICKER_CUSTOM_PLACEHOLDER, DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

// @components
const BrokerOrderTypeCheckbox = require('components/broker/brokerOrderTypeCheckbox/brokerOrderTypeCheckbox');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @commons
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const { AmountInput } = require('commonsComponents/amountInput');
const { InputSafe } = require('commonsComponents/inputSafe');

// @ actions
const BrokerRightsSellActions = require('actions/brokerRightsSell');

const nonNumericRegex = /[^\d]/g;

class BrokerRightsSellStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.handleRightsQuantityChanged = this.handleRightsQuantityChanged.bind(this);
        this.onLimitedValueChanged = this.onLimitedValueChanged.bind(this);
    }

    onLimitedValueChanged(value) {
        this.props.limitedValueChanged(value);
    }

    handleRightsQuantityChanged(event) {
        const value = event.target.value.replace(nonNumericRegex, '').trim();
        this.props.rightsQuantityChanged(value);
    }

    builExcludeDates(maxDate) {
        const limitDate = moment(maxDate).add(1, 'days');
        let excludeDates = [];
        let tempDate = moment();

        while (tempDate.isSameOrBefore(limitDate)) {
            const dayOfWeek = tempDate.day();

            if (dayOfWeek === SUNDAY_INDEX_DAY || dayOfWeek === SATURDAY_INDEX_DAY) {
                excludeDates.push(tempDate.clone());
            }

            tempDate = tempDate.add(1, 'days');
        }

        return excludeDates;
    }

    conditionalInput() {
        const { immBrokerRightsSell, catalogData } = this.props;
        const limitedValue = formatAmount(immBrokerRightsSell.get('steps').get(FIRST_STEP).get('orderTypeValue'), getLanguage(), BROKER_TYPE_RIGHT_NEW_DECIMALS);
        const limitedLabel = catalogData.get('operatedByLot') ?
            (
                <div className="stocks-buy-step1__input-foot">
                    {formatText('brokerOperacionPorLotes-brokerOperacionPorLotes_rightsLimitPrice')}
                </div>
            ) : null;

        return (
            <div className="stocks-sell-step1__text-input-wrapper">
                <AmountInput
                    amount={limitedValue}
                    callback={this.onLimitedValueChanged}
                    max={BROKER_RIGHTS_BUY_FIELDS_MAXLENGHT_LIMIT}
                    maxBackEndFractionLength={BROKER_TYPE_RIGHT_NEW_DECIMALS}
                    hideFocusZero={true}
                    language={language}
                />
                {limitedLabel}
            </div>
        );
    }

    render() {
        const { immBrokerRightsSell, validityDateChanged, orderTypeChanged, maxDate, catalogData } = this.props;
        const step1 = immBrokerRightsSell.get('steps').get(FIRST_STEP);
        const rightsQuantity = step1.get('rightsQuantity');
        const rightsQuantityIsValid = step1.get('rightsQuantityIsValid');
        const rightsQuantityDirty = step1.get('rightsQuantityDirty');
        const validityDate = step1.get('validityDate');
        const orderTypeOption = step1.get('orderTypeOption');
        const minorThanLote = step1.getIn(['errorFlags', 'minorThanLote']);
        const notMultiploLote = step1.getIn(['errorFlags', 'notMultiploLote']);
        const excludeDates = this.builExcludeDates(maxDate);

        let limitedInput;
        let tooltipLot = null;
        let operatedByLotLabel;
        let inputFootValidator;
        let errorMessage = formatText('broker-rightsBuyStep1ErrorText');

        if (orderTypeOption === BROKER_ORDER_TYPE_LIMITED) {
            limitedInput = this.conditionalInput();
        }
        if (catalogData.get('operatedByLot')) {
            tooltipLot = (
                <OKTooltip
                    iconClass="icon icon-pregunta"
                    offset={[0, -5]}
                    content={formatText('brokerOperacionPorLotes-brokerOperacionPorLotes_operatedByLotsRights')}
                />
            );

            const valueLabel = formatAmount(Number((rightsQuantity * catalogData.get('lotValue') / catalogData.get('lot')).toFixed(3)));
            operatedByLotLabel = <FormattedText className="stocks-buy-step1__input-foot"  value="brokerOperacionPorLotes-brokerOperacionPorLotes_buyByRights" injectedStrings={[catalogData.get('lot'), valueLabel]}/>;

            if(!rightsQuantityIsValid && !rightsQuantityDirty) {
                errorMessage = formatText('broker-rightsBuyStep1ErrorText');
            } else {
                if (notMultiploLote && !minorThanLote) {
                    errorMessage = formatText('brokerOperacionPorLotes-brokerOperacionPorLotes_notMultiploRights');
                }
                if (minorThanLote) {
                    errorMessage = <FormattedText value="brokerOperacionPorLotes-brokerOperacionPorLotes_notEnoughRightsForLotError" injectedStrings={[catalogData.get('lot')]}/>;
                }
            }
            inputFootValidator = (notMultiploLote || minorThanLote) ? undefined : operatedByLotLabel;
        }

        return (
            <article className="broker-rights-sell-step1">
                <header className="broker-rights-sell-step1__header">
                    <h2 className="broker-rights-sell-step1__header-title">
                        <FormattedText value="broker-rightsSellStep1HeaderTitle" />
                    </h2>
                    <h4 className="broker-rights-sell-step1__header-subtitle">
                        <FormattedText value="broker-rightsSellStep1HeaderSubtitle" />
                    </h4>
                </header>
                <div className="broker-rights-sell-step1__group-div">
                    <h2 className="broker-rights-sell-step1__subtitle">
                        <FormattedText
                            value="broker-rightsSellStep1RightsAmountText"
                            className="broker-rights-sell-step1__subtitle-text"
                        />
                        {tooltipLot}
                    </h2>
                    <div className="broker-rights-sell-step1__input-container">
                        <InputSafe
                            value={rightsQuantity}
                            autoComplete="off"
                            onChange={this.handleRightsQuantityChanged}
                            errorState={!rightsQuantityIsValid && !rightsQuantityDirty || minorThanLote || notMultiploLote}
                            errorMessage={errorMessage}
                        />
                        {inputFootValidator}
                    </div>
                </div>
                <div className="broker-rights-sell-step1__group-div">
                    <div className="broker-rights-sell-step1__datepicker-label">
                        <h2 className="broker-rights-sell-step1__subtitle">
                            <FormattedText
                                value="broker-rightsSellStep1TermOfValidityText"
                                className="broker-rights-sell-step1__subtitle-text"
                            />
                        </h2>
                    </div>
                    <div className="broker-rights-sell-step1__date-picker">
                        <DatePickerCustom
                            callback={validityDateChanged}
                            selectedDate={validityDate}
                            maxDate={moment(maxDate).endOf('day')}
                            excludeDates={excludeDates}
                            placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                            locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                            dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                        />
                    </div>
                </div>
                <div className="broker-rights-sell-step1__group-div">
                    <h2 className="broker-rights-sell-step1__subtitle">
                        <FormattedText
                            value="broker-rightsSellStep1OrderTypeText"
                            className="broker-rights-sell-step1__subtitle-text"
                        />
                    </h2>
                    <BrokerOrderTypeCheckbox
                        onChange={orderTypeChanged}
                        value={orderTypeOption}
                        productCurrency={EURO_TEXT}
                    />
                    {limitedInput}
                </div>
            </article>
        );
    }
}

BrokerRightsSellStep1.propTypes = {
    immBrokerRightsSell: PropTypes.object.isRequired,
    maxDate: PropTypes.object.isRequired,
    rightsQuantityChanged: PropTypes.func.isRequired,
    validityDateChanged: PropTypes.func.isRequired,
    orderTypeChanged: PropTypes.func.isRequired,
    limitedValueChanged: PropTypes.func.isRequired,
    catalogData: PropTypes.object.isRequired
};

module.exports.constructor = BrokerRightsSellStep1;

module.exports.BrokerRightsSellStep1 = connect(null, {
    rightsQuantityChanged: BrokerRightsSellActions.rightsQuantityChanged,
    validityDateChanged: BrokerRightsSellActions.validityDateChanged,
    orderTypeChanged: BrokerRightsSellActions.orderTypeChanged,
    limitedValueChanged: BrokerRightsSellActions.limitedValueChanged
})(BrokerRightsSellStep1);
